import type { Permission } from '@/api/endpoints/auth';

// Área (permissão) -> rota do painel.
export const PERMISSION_ROUTE: Record<Permission, string> = {
  dashboard: '/',
  devices: '/devices',
  errors: '/errors',
  logs: '/logs',
  uptime: '/uptime',
  users: '/admin',
  plans: '/plans',
  finance: '/financas',
  support: '/suporte',
  settings: '/settings',
  team: '/equipe',
  careers: '/contratacoes',
  orcamentos: '/orcamentos',
  notifications: '/notificacoes',
};

// Primeira rota que o manager consegue acessar (landing pós-login / fallback de 403).
export function firstAccessibleRoute(perms: Permission[] | undefined): string {
  const order: Permission[] = [
    'dashboard',
    'users',
    'support',
    'plans',
    'finance',
    'devices',
    'errors',
    'logs',
    'uptime',
    'settings',
    'team',
    'careers',
    'orcamentos',
    'notifications',
  ];
  for (const p of order) {
    if (perms?.includes(p)) return PERMISSION_ROUTE[p];
  }
  return '/login';
}
